import { buildOptions, getEndPoints } from "@/utils/api-call";
import { makeCall, makeDownload } from "@/utils/request";
import { downloadFile } from "@/utils/download-file";
import * as consts from "./constants";
import * as storeUtils from "@/utils/store-handler";

export const state = {
  extracts: {
    data: [],
    meta: {
      pagination: {
        count: 0,
        current_page: 1,
        per_page: 30,
        total: 0,
        total_pages: 0
      }
    }
  },
  extractsType: [],
  extractNotification: {}
};

export const getters = {
  [consts.GETTERS_EXTRACTS]: state => {
    return state.extracts;
  },
  [consts.GETTERS_EXTRACTS_TYPE]: state => {
    return state.extractsType;
  },
  [consts.GETTERS_EXTRACT_NOTIFICATION]: state => {
    return state.extractNotification;
  },
};

export const actions = {
  [consts.ACTION_GET_EXTRACTS]: ({ commit }, options) => {
    const getExtractsUrl = getEndPoints().extracts.getExtracts.replace(
      ":clientId", options.clientId
    ).replace(
      ":extractType", options.extractType
    );
    makeCall(
      getExtractsUrl,
      buildOptions("GET", { params: options.params }),
      commit
    ).then(
      response => {
        commit(consts.MUTATION_SET_EXTRACTS, response);

        if (options.callback) {
          options.callback();
        }
      },
      error => {
        console.log("Error retrieving extracts", error);
        options.errorHandling(storeUtils.handleErrorMessage(error));
        commit(consts.MUTATION_SET_EXTRACTS, {
          data: [],
          meta: {
            pagination: {
              count: 0,
              current_page: 1,
              per_page: 30,
              total: 0,
              total_pages: 0
            }
          }
        });
      }
    );
  },
  [consts.ACTION_GET_EXTRACT_TYPES]: ({ commit }, options) => {
    const url = getEndPoints().extracts.getExtractsType;
    makeCall(
      url,
      buildOptions("GET"),
      commit
    ).then(
      response => {
        commit(consts.MUTATION_SET_EXTRACT_TYPES, response);
      },
      error => {
        console.log("Error retrieving extracts type", error);
        options.errorHandling(storeUtils.handleErrorMessage(error));
      }
    );
  },
  [consts.ACTION_REQUEST_GENERATE_REPORTS]: ({ commit }, options) => {
    const url = getEndPoints().extracts.requestGenerateReports;
    makeCall(
      url,
      buildOptions("POST", options.payload ),
      commit
    ).then(
      response => {
        if (options.callback) {
          options.callback(response);
        }
      },
      error => {
        console.log("Error request generate reports", error);
        options.errorHandling(storeUtils.handleErrorMessage(error));
      }
    );
  },
  [consts.ACTION_DOWNLOAD_EXTRACT]: ({ commit }, options) => {
    const downloadExtractUrl = getEndPoints().extracts.downloadExtract.replace(
      ":id", options.id
    ).replace(
      ":subFileId", options.subFileId
    );
    makeDownload(
      downloadExtractUrl,
      buildOptions("GET", { responseType: "blob" }),
      commit
    ).then(
      response => {
        const contentDisposition = response.headers['content-disposition'];
        const matches = contentDisposition.match(/filename="([^"]*)"/);
        const filename = matches && matches.length > 1 ? matches[1] : 'extract.csv';

        downloadFile(response.data, filename);
      },
      error => {
        console.log("Error downloading extract", error);
        options.errorHandling(storeUtils.handleErrorMessage(error));
      }
    );
  },
  [consts.ACTION_GET_EXTRACT_NOTIFICATION]: ({ commit }, options) => {
    const url = getEndPoints().extracts.notification.replace(
      ":userId",
      options.userId
    );
    makeCall(
      url,
      buildOptions("GET"),
      commit
    ).then(
      response => {
        commit(consts.MUTATION_SET_EXTRACT_NOTIFICATION, response);

        if (options.callback) {
          options.callback();
        }
      },
      error => {
        console.log("Error getting extract notification", error);
      }
    );
  },
};

export const mutations = {
  [consts.MUTATION_SET_EXTRACTS]: (state, response) => {
    state.extracts = response;
  },
  [consts.MUTATION_SET_EXTRACT_TYPES]: (state, response) => {
    state.extractsType = response.data;
  },
  [consts.MUTATION_SET_EXTRACT_NOTIFICATION]: (state, response) => {
    state.extractNotification = response;
  },
};

export default {
  actions,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/extracts/index.js